export default class PathUtil {
  static makePath(alias: string): string {
    let result = alias
    if (drupalSettings.path.baseUrl !== '/') {
      result = drupalSettings.path.baseUrl + alias.replace(/^\//, '')
    }
    return result
  }
}
